import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "feedBack";

export default function FeedBack() {
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.feedBackOpen}
      successText={(r) => `Обращение отправлено. Номер обращения #${r.success}`}
      goalSent={GOALS.feedBackSent}
    />
  );
}
